import React from 'react'
import { useLoad } from '../../../../../../shared/hooks/load'
import { useApiBlobFileTradeshow, useApiFormFileTradeshow } from '../../../../../../api-new/state/storage'
import { UppyImageUpload } from '../../../../../../shared/image-upload/uppy-image-upload'
import { HERO_OUTPUT } from '../../../../../../shared/image-upload/image-upload-config'
import { Card } from '../../../../../../shared/card/card'

export const TradeshowLogo = ({ identifier }) => {
  const apiFormFileTradeshow = useApiFormFileTradeshow()
  const apiBlobFileTradeshow = useApiBlobFileTradeshow()

  useLoad(async () => {
    if (identifier) {
      await apiBlobFileTradeshow.get(`stream-safe?storageKey=${identifier}`)
    }
  }, [identifier])

  const resolveTarget = async () => ({
    url: `${process.env.REACT_APP_API_STORAGE}/api/v1/file-tradeshow?storageKey=${identifier}`,
    method: 'POST',
  })

  const handleUploaded = async () => {
    await apiBlobFileTradeshow.get(`stream-safe?storageKey=${identifier}`)
  }

  const handleDelete = async () => {
    // Query-shaped like POST/stream-safe — the storage service keys everything
    // off ?storageKey= (the old path-shaped delete never matched a route).
    await apiFormFileTradeshow.delete(`?storageKey=${identifier}`)
    apiBlobFileTradeshow.init()
  }

  // Its own card: the logo saves on its own, never with the form's Update.
  return (
    <Card title="Logo">
      <UppyImageUpload
        previewBlob={apiBlobFileTradeshow.blob}
        aspect={[16, 9]}
        output={HERO_OUTPUT}
        maxFileSize={500 * 1024}
        noun="logo"
        hint="Shown at 16:9 across the top of the trade show's sign-up page. Best at 1280×720 or larger; a PNG keeps its transparency."
        resolveTarget={resolveTarget}
        onUploaded={handleUploaded}
        onDelete={handleDelete}
      />
    </Card>
  )
}
